<template>
    <a @click="toggle(node.id)" class="collapse-button" v-if="hasAnyChildren(node.id)">
        <span class="icon">
            <i v-if="isExpandedNode(node.id)" class="fa fa-caret-square-up" />
            <i v-else class="fa fa-caret-square-down" />
        </span>
    </a>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { useCategoriesManagerStore } from "./categoriesManagerStore";
    import type { CategoryNode } from "../Api/Categories/categories";

    defineProps<{
        node: CategoryNode;
    }>();

    const store = useCategoriesManagerStore();

    const hasAnyChildren = computed(() => store.hasAnyChildren);
    const isExpandedNode = computed(() => store.isExpandedNode);

    function toggle(id: number) {
        store.toggleNode(id);
    }
</script>

<style scoped></style>
